<template>
  <div class="modal fade" id="successMsgModal" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <img
            @click="redirectToLogin"
            src="/static/images/icons/close_icon.svg"
            class="close-icon"
            alt="close-icon"
          />
          <div class="card text-center">
            <img
              src="../../../public/static/images/icons/checkbox.svg"
              alt="checkbox-icon"
              class="success_logo"
            />
            <div class="card-title">
              <p class="verification-text">
                A verification link has been sent to your email account
              </p>
            </div>
            <div class="row">
              <div class="col-lg-12 card-text">
                <p class="success-message">
                  Please check your email for a verification link in order to access your newly
                  created account or click on
                  <a class="link" href="/verificationlink">request new link</a>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 ok-btn">
              <button class="btn btn-block emergo-green-button" @click="redirectToLogin()">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['successMessage'],
  methods: {
    redirectToLogin() {
      this.$router.push({
        name: 'login',
        params: { successMessage: 'Your account is confirmed now. Please login.' },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.modal {
  .modal-dialog {
    .modal-content {
      border-radius: $radius10;
      .modal-header {
        background: $white;
        border-radius: $radius10;
        padding-top: 45px;
        padding-bottom: 40px;
      }
    }
  }
}
img {
  &.success_logo {
    width: 50px;
    height: 50px;
    background-color: $light-green;
    border-radius: 50%;
    padding: 10px;
    margin-top: 5px;
  }
}
.success-message {
  padding: 10px 120px 20px;
  color: $dark-black-alpha;
  font-size: $font-16;
  font-weight: $font-weight-400;
  a {
    @include fontItems($font-16, 19px, $font-weight-600);
    color: $messenger-blue;
  }
}
.ok-btn {
  width: 27%;
  margin: auto;
  float: initial;
  a {
    color: $white;
  }
}
p {
  &.verification-text {
    padding: 20px 70px 10px;
    color: $dark-black-alpha;
    @include fontItems($font-24, 28px, $font-weight-medium);
  }
}
.close-icon {
  position: absolute;
  top: 24px;
  right: 20px;
  cursor: pointer;
}
</style>
